<template>
  <div class="set-border p30">
    <p class="title">素材边框-上下左右</p>
    <div class="box-content">
      <div class="box-left">
        <div v-for="(item,idx,i) in items" :key="idx">
          <div class="label">边框{{i+1}}</div>
          <div class="border p10">
            <div class="box">
              <div>位置</div>
              <div>上</div>
              <div>下</div>
              <div>左</div>
              <div>右</div>
              <!-- <el-checkbox v-model="item.seat[0]" label="四边"></el-checkbox>
              <el-checkbox v-model="item.seat[1]" label="上"></el-checkbox>
              <el-checkbox v-model="item.seat[2]" label="下"></el-checkbox>
              <el-checkbox v-model="item.seat[3]" label="左"></el-checkbox>
              <el-checkbox v-model="item.seat[4]" label="右"></el-checkbox>-->
            </div>
            <div class="box">
              <div>宽度</div>
              <el-input
                class="ml6 after"
                @change="width_fn(idx,'Top')"
                v-model="items[idx].top.width"
                size="mini"
              ></el-input>
              <el-input
                class="ml6 after"
                @change="width_fn(idx,'Bottom')"
                v-model="items[idx].bottom.width"
                size="mini"
              ></el-input>
              <el-input
                class="ml6 after"
                @change="width_fn(idx,'Left')"
                v-model="items[idx].left.width"
                size="mini"
              ></el-input>
              <el-input
                class="ml6 after"
                @change="width_fn(idx,'Right')"
                v-model="items[idx].right.width"
                size="mini"
              ></el-input>
            </div>
            <div class="box">
              <div>样式</div>
              <el-select
                class="ml6"
                size="mini"
                @change="style_fn(idx,'Top')"
                v-model="items[idx].top.style"
                placeholder="请选择"
              >
                <el-option
                  v-for="(style,key) in items_style"
                  :key="key"
                  :label="style.label"
                  :value="style.value"
                ></el-option>
              </el-select>
              <el-select
                class="ml6"
                size="mini"
                @change="style_fn(idx,'Bottom')"
                v-model="items[idx].bottom.style"
                placeholder="请选择"
              >
                <el-option
                  v-for="(style,key) in items_style"
                  :key="key"
                  :label="style.label"
                  :value="style.value"
                ></el-option>
              </el-select>
              <el-select
                class="ml6"
                size="mini"
                @change="style_fn(idx,'Left')"
                v-model="items[idx].left.style"
                placeholder="请选择"
              >
                <el-option
                  v-for="(style,key) in items_style"
                  :key="key"
                  :label="style.label"
                  :value="style.value"
                ></el-option>
              </el-select>
              <el-select
                class="ml6"
                size="mini"
                @change="style_fn(idx,'Right')"
                v-model="items[idx].right.style"
                placeholder="请选择"
              >
                <el-option
                  v-for="(style,key) in items_style"
                  :key="key"
                  :label="style.label"
                  :value="style.value"
                ></el-option>
              </el-select>
            </div>
            <div class="box">
              <div>颜色</div>
              <div
                class="colorBlock ml6"
                @click="show_color_fn(idx,items[idx].top.color,'Top')"
                :style="{backgroundColor:items[idx].top.color}"
              ></div>
              <div
                class="colorBlock ml6"
                @click="show_color_fn(idx,items[idx].bottom.color,'Bottom')"
                :style="{backgroundColor:items[idx].bottom.color}"
              ></div>
              <div
                class="colorBlock ml6"
                @click="show_color_fn(idx,items[idx].left.color,'Left')"
                :style="{backgroundColor:items[idx].left.color}"
              ></div>
              <div
                class="colorBlock ml6"
                @click="show_color_fn(idx,items[idx].right.color,'Right')"
                :style="{backgroundColor:items[idx].right.color}"
              ></div>
            </div>
            <div class="box">
              <div>弧度</div>
              <el-input
                class="ml6 after"
                size="mini"
                @change="radius_fn(idx,'TopLeft')"
                v-model="items[idx].TopLeft"
              ></el-input>
              <el-input
                class="ml6 after"
                size="mini"
                @change="radius_fn(idx,'TopRight')"
                v-model="items[idx].TopRight"
              ></el-input>
              <el-input
                class="ml6 after"
                size="mini"
                @change="radius_fn(idx,'BottomLeft')"
                v-model="items[idx].BottomLeft"
              ></el-input>
              <el-input
                class="ml6 after"
                size="mini"
                @change="radius_fn(idx,'BottomRight')"
                v-model="items[idx].BottomRight"
              ></el-input>
            </div>
            <div class="box">
              <div>内边距</div>
              <el-input
                class="ml6 after"
                size="mini"
                @change="padding_fn(idx,'Top')"
                v-model="items[idx].top.padding"
              ></el-input>
              <el-input
                class="ml6 after"
                size="mini"
                @change="padding_fn(idx,'Bottom')"
                v-model="items[idx].bottom.padding"
              ></el-input>
              <el-input
                class="ml6 after"
                size="mini"
                @change="padding_fn(idx,'Left')"
                v-model="items[idx].left.padding"
              ></el-input>
              <el-input
                class="ml6 after"
                size="mini"
                @change="padding_fn(idx,'Right')"
                v-model="items[idx].right.padding"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div id="set-border-right" class="box-right border" v-html="node"></div>
    </div>
    <div class="box-footer">
      <div class="confirm" @click="close_fn(1)">确定</div>
      <div class="cancel" @click="close_fn(0)">取消</div>
    </div>
    <com-color v-show="show_color" class="com-color" :value="colorVal" @upColor="upColorFn"></com-color>
  </div>
</template>
<script>
import comColor from "./com-color";
import { constants } from 'fs';
export default {
  name: "set-border",
  data() {
    return {
      show_color: false,
      colorVal: "#000001",
      items_style: [
        { value: "none", label: "无边框" },
        { value: "solid", label: "实线" },
        { value: "dotted", label: "点线" },
        { value: "dashed", label: "虚线" },
        { value: "double", label: "双线" },
        { value: "groove", label: "3D凹槽" },
        { value: "ridge", label: "3D垄状" },
        { value: "inset", label: "3D内嵌" },
        { value: "outset", label: "3D外嵌" }
      ]
    };
  },
  props: {
    items: {
      type: Object,
      default: {}
    },
    node: {
      type: String,
      default: {}
    }
  },
  methods: {
    show_color_fn(key, color, attr) {
      this.key = key;
      this.attr = attr;
      this.colorVal = color;
      this.show_color = true;
    },
    upColorFn(newColor) {
      console.log(newColor);
      this.$set(
        this.items[this.key][this.attr.toLowerCase()],
        "color",
        newColor
      );
      this.colorVal = newColor;
      this.border_fn(this.key, this.attr);
    },
    width_fn(key, attr) {
      this.key = key;
      this.attr = attr;
      this.border_fn(key, attr);
    },
    style_fn(key, attr) {
      this.key = key;
      this.attr = attr;
      this.border_fn(key, attr);
    },
    radius_fn(key, attr) {
      let node = $("#set-border-right").find(`[data-border=${key}]`)[0];
      node.style[`border${attr}Radius`] = this.items[key][attr] + "px";
    },
    padding_fn(key, attr) {
      this.key = key;
      this.attr = attr;
      let node = $("#set-border-right").find(`[data-border=${key}]`)[0];
      node.style[`padding${attr}`] =
        this.items[key][attr.toLowerCase()].padding + "px";
    },
    border_fn(key, attr) {
      this.key = key;
      this.attr = attr;
      let item = this.items[key][attr.toLowerCase()];
      let node = $("#set-border-right").find(`[data-border=${key}]`)[0];
      node.style[`border${attr}`] =
        item.width + "px " + item.style + " " + item.color;
    },
    close_fn(idx) {
      if (idx) {
        this.$emit(
          "msg_close_set_border",
          $("#set-border-right .ihuyiEditor").html()
        );
      } else {
        this.$emit("msg_close_set_border", false);
      }
    }
  },
  mounted() {
    console.log(this.items);
  },
  watch: {
    items(newVal, oldVal) {},
    node(newVal, oldVal) {}
  },
  components: {
    comColor
  }
};
</script>
<style lang="css">
.el-input__inner {
  padding: 0 5px;
}
.after {
  position: relative;
}

.after input {
  padding-right: 20px;
}
.after::after {
  content: "px";
  display: block;
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
}
.el-select-dropdown__item {
  text-align: center;
}
</style>
<style lang="scss" scoped>
.set-border {
  width: 840px;
  height: 575px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 14px;
  margin: auto;
  background-color: #ffffff;
  color: #535353;
  z-index: 1000;
  box-sizing: border-box;
  .box {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;
    & > * {
      display: block;
    }
  }
  .title {
    font-size: 16px;
  }
}
.label {
  margin: 20px 0 10px;
}
.box-footer {
  height: 18%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  div {
    cursor: pointer;
    width: 98px;
    line-height: 37px;
    font-size: 14px;
    text-align: center;
    border-radius: 5px;
  }
  .confirm {
    color: #ffffff;
    background-color: #a9db46;
    margin-right: 10px;
  }
  .cancel {
    background-color: #f1f3f7;
  }
}
.box-content {
  height: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
}
.colorBlock {
  flex: 0 0 auto;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #535353;
  border: 2px solid #ddd;
}
.ml6 {
  margin-left: 6px;
}
.box-left,
.box-right {
  height: 100%;
}
.box-right {
  width: 48%;
  display: flex;
  align-items: center;
}
.box-left {
  width: 50%;
  box-sizing: border-box;
  padding-right: 2%;
  overflow-y: scroll;
}
.border {
  border: 1px solid #f1f3f7;
}
.p30 {
  padding: 30px;
}
.p10 {
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/com-set-border.vue